import client from './client';

// Lionjob (chỉ Giám đốc + mã code). Backend: /api/lionjob/... (DB tách riêng).
const BASE = '/lionjob/scraped-product-assignments';

// Mã code lưu tạm trong sessionStorage (mất khi đóng tab -> mở lại phải nhập mã).
export const getCode = () => sessionStorage.getItem('lionjob_code') || '';
export const setCode = (c) => sessionStorage.setItem('lionjob_code', c);
export const clearCode = () => sessionStorage.removeItem('lionjob_code');
// timeout 15s: nếu backend treo (vd server production chưa cấu hình DB matrixty) thì báo lỗi
// thay vì "mở khóa" im lặng mãi không phản hồi.
const hdr = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 15000 });
// Riêng gọi Claude (sinh SEO) mất lâu hơn nhiều (Opus 4.8 + thinking + công thức Teeyoung),
// 15s không đủ -> dùng timeout 120s để không bị axios hủy giữa chừng.
const hdrGen = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 120000 });

// Câu báo lỗi cho MÀN KHOÁ. Backend chạy `protect` TRƯỚC `checkCode`, nên hết phiên đăng nhập
// thì 401 "Chưa đăng nhập" bung ra kể cả khi mã code đúng — người dùng lại ngồi thử đi thử lại
// mã. Nói thẳng ra lỗi nào là lỗi nào.
export function lockMessage(e) {
  const m = e?.response?.data?.message || e?.message || 'Không kết nối được backend';
  if (e?.response?.status === 401) return 'Phiên đăng nhập đã hết hạn — KHÔNG phải sai mã code. Tải lại trang và đăng nhập lại.';
  if (e?.response?.data?.code === 'BAD_LIONJOB_CODE') return 'Sai mã code Lionjob.';
  return m;
}

export const listAssignments = (params) => client.get(BASE, { params, ...hdr() }).then((r) => r.data.data);
export const listAccounts = () => client.get('/lionjob/scraped-product-assignments-accounts', hdr()).then((r) => r.data.data);
export const listProducts = (params) => client.get('/lionjob/scraped-products', { params, ...hdr() }).then((r) => r.data.data);
export const getAssignment = (id) => client.get(`${BASE}/${id}`, hdr()).then((r) => r.data.data);
export const updateAssignment = (id, body) => client.patch(`${BASE}/${id}`, body, hdr()).then((r) => r.data.data);
export const markDone = (id) => client.post(`${BASE}/${id}/done`, null, hdr()).then((r) => r.data.data);
// nicheId (tuỳ chọn): kèm ngữ cảnh ngách để Claude bám từ khoá thật thay vì đoán từ mỗi title.
export const generateSeo = (id, nicheId) => client.post(`${BASE}/${id}/generate`, nicheId ? { nicheId } : null, hdrGen()).then((r) => r.data.data);
export const createAssignment = (body) => client.post(BASE, body, hdr()).then((r) => r.data.data);

// ---- Màn Trending (đầu phễu: chọn hàng tiềm năng -> đẩy sang Scraped Products) ----
export const listTrending = (params) => client.get('/lionjob/trending', { params, ...hdr() }).then((r) => r.data.data);
export const trendingCounts = () => client.get('/lionjob/trending/counts', hdr()).then((r) => r.data.data);
export const pushTrending = (ids, force) => client.post('/lionjob/trending/push', { ids, force }, hdr()).then((r) => r.data);
export const skipTrending = (ids) => client.post('/lionjob/trending/skip', { ids }, hdr()).then((r) => r.data);

// ---- Màn Ideas (giữa phễu: kiểm bản quyền + chấm thiết kế) ----
export const listIdeas = (params) => client.get('/lionjob/ideas', { params, ...hdr() }).then((r) => r.data.data);
export const ideasCounts = () => client.get('/lionjob/ideas/counts', hdr()).then((r) => r.data.data);
export const pushIdeas = (ids, force) => client.post('/lionjob/ideas/push', { ids, force }, hdr()).then((r) => r.data);
export const skipIdeas = (ids) => client.post('/lionjob/ideas/skip', { ids }, hdr()).then((r) => r.data);

// ---- Kho mockup (ảnh nhặt từ web, đã tải về server) ----
export const listMockups = (params) => client.get('/lionjob/mockups', { params, ...hdr() }).then((r) => r.data.data);
export const updateMockup = (id, body) => client.patch(`/lionjob/mockups/${id}`, body, hdr()).then((r) => r.data.data);
export const removeMockup = (id) => client.delete(`/lionjob/mockups/${id}`, hdr()).then((r) => r.data);

// ---- Sức khoẻ shop Etsy ----
export const listShopIndex = (params) => client.get('/lionjob/shop-index', { params, ...hdr() }).then((r) => r.data.data);
export const shopHistory = (shop) => client.get(`/lionjob/shop-index/${encodeURIComponent(shop)}/history`, hdr()).then((r) => r.data.data);

// ---- MCP Ytrends (backend nối thẳng tới MCP server) ----
// Kết nối + kéo dữ liệu có thể lâu -> dùng timeout dài như gọi Claude.
export const ytStatus = () => client.get('/lionjob/ytrends/status', hdrGen()).then((r) => r.data.data);
export const ytCall = (tool, args) => client.post('/lionjob/ytrends/call', { tool, args }, hdrGen()).then((r) => r.data.data);
export const ytSync = (body) => client.post('/lionjob/ytrends/sync', body || {}, hdrGen()).then((r) => r.data);
export const ytSnapshot = (day) => client.get('/lionjob/ytrends/snapshot', { params: day ? { day } : {}, ...hdrGen() }).then((r) => r.data.data);

// ---- Tải extension 🦁 ----
// Tải qua axios (KHÔNG dùng thẻ <a href>) vì endpoint đòi JWT + header mã code,
// mà thẻ <a> thì trình duyệt không gắn header nào cả.
export const extInfo = () => client.get('/lionjob/extension/info', hdr()).then((r) => r.data.data);
export const extDownload = () =>
  client.get('/lionjob/extension/download', { ...hdr(), responseType: 'blob', timeout: 60000 })
    .then((r) => {
      const name = (r.headers['content-disposition'] || '').match(/filename="?([^";]+)/)?.[1] || 'lionjob-extension.zip';
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);  // nhả bộ nhớ sau khi trình duyệt đã nuốt
      return name;
    });

// ---- Ngách tự sinh từ cụm từ khoá đang lên ----
// Sinh ngách phải chờ Claude nghĩ (~1 phút) nên dùng timeout dài.
export const listNiches = (params) => client.get('/lionjob/niches', { params, ...hdr() }).then((r) => r.data.data);
export const genNiches = (body) => client.post('/lionjob/niches/generate', body || {}, { ...hdrGen(), timeout: 300000 }).then((r) => r.data);
export const updateNiche = (id, body) => client.patch(`/lionjob/niches/${id}`, body, hdr()).then((r) => r.data.data);
export const removeNiche = (id) => client.delete(`/lionjob/niches/${id}`, hdr()).then((r) => r.data);

// ---- Mã vận đơn (nhập danh sách -> extension điền lên sàn) ----
export const listTracking = (params) => client.get('/lionjob/tracking', { params, ...hdr() }).then((r) => r.data.data);
export const importTracking = (body) => client.post('/lionjob/tracking/import', body, hdr()).then((r) => r.data);
export const removeTracking = (id) => client.delete(`/lionjob/tracking/${id}`, hdr()).then((r) => r.data);

// ---- Redesign (quy trình 3 bước: cutout -> restyle -> tách nền ở trình duyệt) ----
// Sinh ảnh lâu hơn sinh chữ nhiều (1-3 phút/ảnh) -> timeout riêng 5 phút.
const hdrImg = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 300000 });
export const rdStyles = (params) => client.get('/lionjob/redesign/styles', { params, ...hdr() }).then((r) => r.data.data);
export const rdAddStyle = (b) => client.post('/lionjob/redesign/styles', b, hdr()).then((r) => r.data);
export const rdPrompt = (b) => client.post('/lionjob/redesign/prompt', b, hdrGen()).then((r) => r.data.data);
export const rdCutout = (b) => client.post('/lionjob/redesign/cutout', b, hdrImg()).then((r) => r.data);
export const rdRestyle = (b) => client.post('/lionjob/redesign/restyle', b, hdrImg()).then((r) => r.data.data);
export const rdSave = (b) => client.post('/lionjob/redesign/save', b, hdrImg()).then((r) => r.data);
export const rdGenerate = (b) => client.post('/lionjob/redesign/generate', b, hdrImg()).then((r) => r.data);
